import React, { useState, useEffect, useRef } from "react";
import { BASE_URL } from "../../../constants";
import { api } from "../../../utils/api";
import {
  TextField,
  IconButton,
  Tooltip,
  Badge,
  MenuItem,
  Select,
  FormControl,
  Button,
  Avatar,
  Link,
  useMediaQuery,
  Popover,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SendIcon from "@mui/icons-material/Send";
import GroupIcon from "@mui/icons-material/Group";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddIcon from "@mui/icons-material/Add";
import AddCollobrationModal from "./addCollaborationModal";
import { useTheme } from "@mui/material/styles";
import "./chats.css";
import Cookies from "js-cookie";
import {
  ensureSessionReady,
  userDetailsApi,
} from "../../../redux/action/UserAction";
import { useDispatch } from "react-redux";

const Chats = () => {
  const dispatch = useDispatch();
  const [groups, setGroups] = useState([]);
  const [activeGroup, setActiveGroup] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filter, setFilter] = useState("allmessages");
  const [messages, setMessages] = useState({});
  const [newMessage, setNewMessage] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    members: [],
    is_option: false,
  });
  const [accessToken] = useState(Cookies.get("accessToken"));
  const [userType] = useState(sessionStorage.getItem("userType"));
  const [groupId] = useState(sessionStorage.getItem("currentGrp"));
  const [createdBy] = useState(sessionStorage.getItem("createdBy"));
  const [IsAdmin] = useState(sessionStorage.getItem("IsAdmin"));
  const [participants, setParticipants] = useState([]);
  const socketRef = useRef(null);
  const [nextPage, setNextPage] = useState({});
  const messageEndRef = useRef(null);
  const messageContainerRef = useRef(null);

  const currentUser = sessionStorage.getItem("createdBy") || "You";
  const [userData] = useState(sessionStorage.getItem("full_name") || "You");
  const theme = useTheme();
  const isTouchDevice = useMediaQuery("(hover: none)");

  const [showSuggestions, setShowSuggestions] = useState(false);
  const [mentionQuery, setMentionQuery] = useState("");
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [selectedSuggestionIndex, setSelectedSuggestionIndex] = useState(0);
  const [mentionAnchorEl, setMentionAnchorEl] = useState(null);
  const [participantsAnchorEl, setParticipantsAnchorEl] = useState(null);
  const [currentMentions, setCurrentMentions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState("");
  const [topic, setTopic] = useState([]);

  const openMentionAt = (target) => {
    setMentionAnchorEl(target);
    setShowSuggestions(true);
  };
  const closeMention = () => {
    setShowSuggestions(false);
    setMentionQuery("");
    setFilteredSuggestions([]);
    setSelectedSuggestionIndex(0);
    setMentionAnchorEl(null);
  };

  const handleKeyDownInput = (e) => {
    if (showSuggestions) {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setSelectedSuggestionIndex((s) =>
          Math.min(s + 1, filteredSuggestions.length - 1)
        );
        return;
      }
      if (e.key === "ArrowUp") {
        e.preventDefault();
        setSelectedSuggestionIndex((s) => Math.max(s - 1, 0));
        return;
      }
      if (e.key === "Enter") {
        if (showSuggestions && filteredSuggestions[selectedSuggestionIndex]) {
          e.preventDefault();
          insertMention(filteredSuggestions[selectedSuggestionIndex]);
          return;
        }
      }
      if (e.key === "Escape") {
        closeMention();
        return;
      }
    }

    if (e.key === "Enter" && !showSuggestions) {
      e.preventDefault();
      handleSend();
    }
  };

  // update suggestion list whenever mentionQuery or participants change
  useEffect(() => {
    const everyoneItem = {
      id: "everyone",
      user_name: "Everyone",
      _everyone: true,
    };

    if (mentionQuery === null || mentionQuery === undefined)
      setMentionQuery("");

    if (!mentionQuery) {
      const list = [everyoneItem, ...participants.slice(0, 6)];
      setFilteredSuggestions(list);
      setSelectedSuggestionIndex(0);
      return;
    }

    const q = mentionQuery.toLowerCase();
    const matched = participants
      .filter((p) => p.user_name && p.user_name.toLowerCase().includes(q))
      .slice(0, 6);

    const includeEveryone = "everyone".includes(q) || q === "@" || q === "";
    const list = includeEveryone ? [everyoneItem, ...matched] : matched;

    setFilteredSuggestions(list);
    setSelectedSuggestionIndex(0);
  }, [mentionQuery, participants]);

  /** Format date nicely */
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  /** Fetch group list */
  const fetchGroups = async () => {
    const groupId = sessionStorage.getItem("currentGrp");
    try {
      setLoading(true);
      const res = await api.get(
        `${BASE_URL}/getgroups/?group_id=${groupId}&filter=${filter}`
      );
      const groups = res.data;
      groups.sort((a, b) => {
        if (a.IsMentioned && !b.IsMentioned) return -1;
        if (!a.IsMentioned && b.IsMentioned) return 1;
        if ((a.total_unreads || 0) > 0 && (b.total_unreads || 0) === 0)
          return -1;
        if ((a.total_unreads || 0) === 0 && (b.total_unreads || 0) > 0)
          return 1;
        const dateA = new Date(a.last_updated || a.updated_at || 0);
        const dateB = new Date(b.last_updated || b.updated_at || 0);
        return dateB - dateA;
      });
      setGroups(groups);
      suggestedTopics();
    } catch (error) {
      // console.error("Error fetching groups:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleScroll = async () => {
    if (!activeGroup?.id) return;
    const container = messageContainerRef.current;

    if (container.scrollTop === 0 && nextPage[activeGroup.id]) {
      const prevHeight = container.scrollHeight;

      await fetchMessages(activeGroup.id, nextPage[activeGroup.id], true);
      requestAnimationFrame(() => {
        const newHeight = container.scrollHeight;
        container.scrollTop = newHeight - prevHeight;
      });
    }
  };

  const fetchMessages = async (grpId, url = null, prepend = false) => {
    try {
      const res = await api.get(url || `${BASE_URL}/messages/${grpId}/`);
      const { results, next } = res.data;

      const normalized = results.map((m) => ({
        id: m.id,
        groupId: m.room,
        username: String(m.user),
        message: m.content,
        date: m.timestamp,
        userData: m.user__username,
        hasMention: containsMention(m.content, userData),
      }));

      setMessages((prev) => {
        const existing = prev[grpId] || [];
        return {
          ...prev,
          [grpId]: prepend ? [...normalized, ...existing] : normalized,
        };
      });

      setNextPage((prev) => ({ ...prev, [grpId]: next }));
    } catch (error) {
      // console.error("Error fetching messages:", error);
    }
  };

  const containsMention = (text, userFullName) => {
    if (!text || !userFullName) return false;
    return text.toLowerCase().includes(`@${userFullName.toLowerCase()}`);
  };

  const scrollToBottom = (smooth = true) => {
    messageEndRef.current?.scrollIntoView({
      behavior: smooth ? "smooth" : "auto",
    });
  };

  useEffect(() => {
    if (!activeGroup?.id) return;

    const msgs = messages[activeGroup.id] || [];
    if (!msgs.length) return;

    const container = messageContainerRef.current;
    if (!container) return;

    const isAtBottom =
      container.scrollHeight - container.scrollTop <=
      container.clientHeight + 100;

    if (isAtBottom) {
      scrollToBottom();
    }
  }, [messages, activeGroup?.id]);

  useEffect(() => {
    if (activeGroup?.id) {
      fetchMessages(activeGroup.id).then(() => {
        requestAnimationFrame(() => scrollToBottom(false));
      });
    }
  }, [activeGroup]);

  /** Mark all collaboration groups as read on server and update UI */
  const markAllAsRead = async () => {
    const groupId = sessionStorage.getItem("currentGrp");
    try {
      await api.post(`${BASE_URL}/mark-all-read/`, { group_id: groupId });
      setMessages((prev) => {
        const copy = { ...prev };
        Object.keys(copy).forEach((k) => {
          copy[k] = (copy[k] || []).map((m) => ({ ...m, isUnread: false }));
        });
        return copy;
      });

      setGroups((prev) =>
        prev.map((g) => ({
          ...g,
          total_unreads: 0,
          ismesssageread: true,
          IsMentioned: false,
        }))
      );
    } catch (error) {
      // console.error("Error marking all messages as read:", error);
    }
  };

  /** Mark a single group as read on the server and update UI */
  const markGroupAsRead = async (collabrationgroup_id) => {
    const groupId = sessionStorage.getItem("currentGrp");
    try {
      await api.post(`${BASE_URL}/mark-read/`, {
        collabrationgroup_id,
        group_id: groupId,
      });
      setMessages((prev) => ({
        ...prev,
        [collabrationgroup_id]: (prev[collabrationgroup_id] || []).map((m) => ({
          ...m,
          isUnread: false,
        })),
      }));
      setGroups((prev) =>
        prev.map((g) =>
          g.id === collabrationgroup_id
            ? {
              ...g,
              total_unreads: 0,
              ismesssageread: true,
              IsMentioned: false,
            }
            : g
        )
      );
    } catch (error) {
      // console.error("Error calling mark-read:", error);
    }
  };

  /** Mark all collaboration groups as read on server and update UI */

  /** Create group */
  const handleCreateGroup = async (newGroupData) => {
    const groupId = sessionStorage.getItem("currentGrp");
    try {
      const membersPayload = newGroupData.members.map((m) => ({
        user_id: m.id,
      }));
      const res = await api.post(`${BASE_URL}/creategroup/`, {
        collabrationgroupname: newGroupData.name,
        // members: membersPayload,
        group: groupId,
        // unreadmessagecount: 0,
        total_unreads: 0,
        IsMentioned: false,
      });
      const createdGroup = res.data;
      //  fetchGroups();
      setGroups((prev) => [
        { ...createdGroup, last_updated: new Date().toISOString() },
        ...prev,
      ]);
      setMessages((prev) => ({ ...prev, [createdGroup.id]: [] }));
      setModalOpen(false);
      suggestedTopics();
    } catch (error) {
      // console.error("Error creating group:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.collabrationgroupname
      ) {
        const apiMessage = error.response.data.collabrationgroupname[0];
        setApiError(apiMessage);
      } else {
        setApiError("Something went wrong while creating the group.");
      }
    }
  };

  /** Fetch participants */
  const fetchParticipants = async (grpId) => {
    const groupId = sessionStorage.getItem("currentGrp");
    try {
      const res = await api.get(
        `${BASE_URL}/getmember?group_id=${groupId}&collabrationgroup_id=${activeGroup.id}`
      );
      const participants = res.data || [];
      setParticipants(participants);
    } catch (error) {
      // console.error("Error fetching participants:", error);
    }
  };

  useEffect(() => {
    if (!activeGroup?.id) return;

    const protocol = window.location.protocol === "https:" ? "wss" : "ws";
    const host = BASE_URL.replace(/^https?:\/\//, "");
    const wsUrl = `${protocol}://api.qtools.ai/ws/chat/${activeGroup.id}/?token=${accessToken}`;

    socketRef.current = new WebSocket(wsUrl);

    socketRef.current.onopen = () => console.log("WS connected:", wsUrl);

    socketRef.current.onmessage = (event) => {
      // console.log(event, "Test");
      try {
        const msg = JSON.parse(event.data);
        if (msg.type === "mention_notification") {
          const roomId = parseInt(msg.room, 10);
          const isMentioned = msg.IsMentioned ?? true;

          setGroups((prev) => {
            const updated = prev.map((g) =>
              g.id === roomId
                ? {
                  ...g,
                  IsMentioned:
                    roomId === activeGroup?.id ? false : isMentioned,
                  last_updated: new Date().toISOString(),
                }
                : g
            );
            return [...updated].sort((a, b) => {
              if (a.IsMentioned && !b.IsMentioned) return -1;
              if (!a.IsMentioned && b.IsMentioned) return 1;

              if ((a.total_unreads || 0) > 0 && (b.total_unreads || 0) === 0)
                return -1;
              if ((a.total_unreads || 0) === 0 && (b.total_unreads || 0) > 0)
                return 1;

              const dateA = new Date(a.last_updated || a.updated_at || 0);
              const dateB = new Date(b.last_updated || b.updated_at || 0);
              return dateB - dateA;
            });
          });

          return;
        }
        if (msg.type === "unread_count_update") {
          const roomId = parseInt(msg.room, 10);
          const count = msg.unread_count ?? 0;

          setGroups((prev) => {
            const updated = prev.map((g) =>
              g.id === roomId
                ? {
                  ...g,
                  total_unreads: roomId === activeGroup?.id ? 0 : count,
                  ismesssageread: roomId === activeGroup?.id,
                  last_updated: new Date().toISOString(),
                }
                : g
            );
            return [...updated].sort((a, b) => {
              if (a.IsMentioned && !b.IsMentioned) return -1;
              if (!a.IsMentioned && b.IsMentioned) return 1;

              if ((a.total_unreads || 0) > 0 && (b.total_unreads || 0) === 0)
                return -1;
              if ((a.total_unreads || 0) === 0 && (b.total_unreads || 0) > 0)
                return 1;

              const dateA = new Date(a.last_updated || a.updated_at || 0);
              const dateB = new Date(b.last_updated || b.updated_at || 0);
              return dateB - dateA;
            });
          });

          return;
        }
        const normalized = {
          id: msg.id || Date.now(),
          groupId: msg.room || msg.groupId || activeGroup?.id,
          username: String(msg.user || msg.username || "Unknown"),
          message: msg.content || msg.message,
          date: msg.timestamp || msg.date || new Date().toISOString(),
          userData:
            msg.user__username || msg.userData || msg.username || "Unknown",
          hasMention: containsMention(msg.content || msg.message, userData),
          type: msg.type || "message",
        };
        setMessages((prev) => {
          const existing = prev[normalized.groupId] || [];
          if (existing.some((m) => m.id === normalized.id)) return prev;
          return {
            ...prev,
            [normalized.groupId]: [...existing, normalized],
          };
        });
        setGroups((prev) => {
          const updated = prev.map((g) => {
            if (g.id === normalized.groupId) {
              if (normalized.groupId === activeGroup?.id) {
                return {
                  ...g,
                  total_unreads: 0,
                  ismesssageread: true,
                  last_updated: new Date().toISOString(),
                  IsMentioned: false,
                };
              } else {
                return {
                  ...g,
                  total_unreads: (g.total_unreads || 0) + 1,
                  ismesssageread: false,
                  last_updated: new Date().toISOString(),
                  IsMentioned:
                    g.IsMentioned || normalized.type === "mention_notification",
                };
              }
            }
            return g;
          });

          return [...updated].sort((a, b) => {
            if (a.IsMentioned && !b.IsMentioned) return -1;
            if (!a.IsMentioned && b.IsMentioned) return 1;

            if ((a.total_unreads || 0) > 0 && (b.total_unreads || 0) === 0)
              return -1;
            if ((a.total_unreads || 0) === 0 && (b.total_unreads || 0) > 0)
              return 1;

            const dateA = new Date(a.last_updated || a.updated_at || 0);
            const dateB = new Date(b.last_updated || b.updated_at || 0);
            return dateB - dateA;
          });
        });
        if (normalized.groupId === activeGroup?.id) {
          markGroupAsRead(activeGroup.id);
          scrollToBottom();
        }
      } catch (err) {
        // console.error("Invalid WS message:", event.data);
      }
    };

    socketRef.current.onclose = () => console.log("WS disconnected");
    socketRef.current.onerror = (err) => console.error("WS error:", err);

    return () => {
      if (socketRef.current?.readyState === WebSocket.OPEN) {
        socketRef.current.close();
      }
    };
  }, [activeGroup?.id]);

  const insertMention = (participant) => {
    if (!participant) return;

    const caret =
      document.getElementById("chat-input")?.selectionStart ||
      newMessage.length;
    const uptoCaret = newMessage.slice(0, caret);
    const lastAt = uptoCaret.lastIndexOf("@");

    const mentionText = participant._everyone
      ? "Everyone"
      : participant.user_name;

    if (lastAt === -1) {
      const updated = `${newMessage} @${mentionText} `;
      setNewMessage(updated);
    } else {
      const before = newMessage.slice(0, lastAt);
      const after = newMessage.slice(caret);
      const updated = `${before}@${mentionText} ${after}`;
      setNewMessage(updated);
    }

    closeMention();
    setTimeout(() => document.getElementById("chat-input")?.focus(), 0);
  };

  const handleSend = async () => {
    if (!newMessage.trim() || !activeGroup?.id) return;
    const mentionPattern = /@([^\s@]+)/g;
    const mentions = [];
    let match;
    let hasEveryone = false;

    while ((match = mentionPattern.exec(newMessage)) !== null) {
      const name = match[1].trim();

      if (name.toLowerCase() === "everyone") {
        hasEveryone = true;
        continue;
      }

      const found = participants.find(
        (p) => p.user_name && p.user_name.toLowerCase() === name.toLowerCase()
      );

      if (found) {
        mentions.push({ id: found.user_id, user_name: found.user_name });
      }
    }

    if (hasEveryone) {
      participants.forEach((p) => {
        if (p && p.user_id)
          mentions.push({ id: p.user_id, user_name: p.user_name });
      });
    }

    const msgPayload = {
      room: activeGroup.id,
      username: currentUser,
      message: newMessage,
      timestamp: new Date().toISOString(),
      userData: userData,
      mentions,
    };

    if (socketRef.current?.readyState === WebSocket.OPEN) {
      // console.log(msgPayload, "Aman");
      socketRef.current.send(JSON.stringify(msgPayload));
    } else {
      // console.log("WS not open, message payload:", msgPayload);
    }

    setNewMessage("");
    closeMention();
    scrollToBottom();
    // written this line by aman on 09Oct2025 start here
    try {
      await markGroupAsRead(activeGroup.id);
    } catch (err) {
      // console.error("Error marking group as read after sending:", err);
    }
    // written this line by aman on 09Oct2025 end here
  };

  // useEffect(() => {
  //   if (userType && groupId && createdBy) {
  //     fetchGroups();
  //   }
  // }, [filter, userType, groupId, createdBy]);
  // useEffect(() => {
  //   ensureSessionReady(dispatch, () => {
  //     fetchGroups();
  //   });
  // }, [filter]);
  useEffect(() => {
    const timer = setTimeout(() => {
      ensureSessionReady(dispatch, () => {
        fetchGroups();
      });
    }, 1000);
    return () => clearTimeout(timer);
  }, [filter]);

  useEffect(() => {
    if (activeGroup?.id) {
      fetchMessages(activeGroup.id);
      fetchParticipants(activeGroup.id);
    }
  }, [activeGroup]);

  const filteredGroups = groups.filter((group) =>
    group.collabrationgroupname.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredMessages = activeGroup
    ? (messages[activeGroup.id] || []).filter((msg) => {
      switch (filter) {
        case "Unread messages":
          return msg.isUnread;
        case "Mentions":
          return msg.hasMention;
        default:
          return true;
      }
    })
    : [];

  const formatDates = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12;
    hours = hours ? hours : 12;

    return `${month}/${day}/${year} ${hours}:${minutes} ${ampm}`;
  };

  const CollobrationformatDates = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${month}/${day}/${year}`;
  };

  const renderMessageWithMentions = (text) => {
    if (!text) return text;

    const parts = [];
    const regex = /@\S+/g;
    let lastIndex = 0;
    let m;

    while ((m = regex.exec(text)) !== null) {
      const idx = m.index;
      if (idx > lastIndex) parts.push(text.slice(lastIndex, idx));

      const mentionText = m[0];
      parts.push(
        <span className="mention-highlight" key={idx}>
          {mentionText}
        </span>
      );

      lastIndex = idx + mentionText.length;
    }

    if (lastIndex < text.length) {
      parts.push(text.slice(lastIndex));
    }

    return parts.length ? parts : text;
  };

  const handleSetActiveGroup = async (group) => {
    setActiveGroup(group);
    setGroups((prev) =>
      prev.map((g) =>
        g.id === group.id
          ? { ...g, total_unreads: 0, ismesssageread: true, IsMentioned: false }
          : g
      )
    );
    try {
      await markGroupAsRead(group.id);
    } catch (err) {
      // console.error("Error marking group as read on open:", err);
    }
  };

  const suggestedTopics = async () => {
    const groupId = sessionStorage.getItem("currentGrp");
    try {
      // setLoading(true);
      const res = await api.get(`${BASE_URL}/top-topics/?group_id=${groupId}`);
      const topic = res.data;
      const sortedTopics = topic.sort(
        (a, b) => new Date(b.latest_message) - new Date(a.latest_message)
      );
      setTopic(sortedTopics.map((item) => item.topic));
    } catch (error) {
      // console.error("Error fetching topic:", error);
    } finally {
      // setLoading(false);
    }
  };
  // written this code for new created groups automatic updated list start here on 15 Oct 2025
  useEffect(() => {
    const interval = setInterval(() => {
      fetchGroupsSilently();
    }, 10000);
    return () => clearInterval(interval);
  }, [filter]);

  const fetchGroupsSilently = async () => {
    // console.log(loading, "loading1");
    const groupId = sessionStorage.getItem("currentGrp");
    try {
      setLoading(false);
      const res = await api.get(
        `${BASE_URL}/getgroups/?group_id=${groupId}&filter=${filter}`
      );
      const groups = res.data;
      groups.sort((a, b) => {
        if (a.IsMentioned && !b.IsMentioned) return -1;
        if (!a.IsMentioned && b.IsMentioned) return 1;
        if ((a.total_unreads || 0) > 0 && (b.total_unreads || 0) === 0)
          return -1;
        if ((a.total_unreads || 0) === 0 && (b.total_unreads || 0) > 0)
          return 1;
        const dateA = new Date(a.last_updated || a.updated_at || 0);
        const dateB = new Date(b.last_updated || b.updated_at || 0);
        return dateB - dateA;
      });
      setGroups(groups);
      suggestedTopics();
    } catch (error) {
      // console.error("Error fetching groups silently:", error);
    }
  };
  // written this code for new created groups automatic updated list end here on 15 Oct 2025
  return (
    <div className="team-collab-container">
      {/* Sidebar */}
      <div className="sidebar">
        <div className="collaboration">
          <p className="collaboration-text" style={{ fontSize: "14px", fontWeight: "bold" }}>Collaboration</p>
          {/* {userType === "manager" && ( */}
          {IsAdmin === "true" && (
            <Button
              variant="contained"
              className="collaboration-btn"
              style={{ padding: "5px 9px" }}
              sx={{
                backgroundColor: "#6264A7",
                color: "white",
                textTransform: "none",
                fontSize: "11px",
                whiteSpace: "nowrap",
              }}
              onClick={() => setModalOpen(true)}
            >
              <AddIcon sx={{ marginRight: "2px", fontSize: "17px" }} />
              New Collaboration
            </Button>
          )}
        </div>
        <hr className="divider" />
        <TextField
          placeholder="Search collaborations"
          size="small"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: <SearchIcon sx={{ color: "#616161", mr: 1 }} />,
          }}
          fullWidth
        />
        <hr className="divider" />
        <FormControl fullWidth size="small">
          <Select value={filter} onChange={(e) => setFilter(e.target.value)}>
            <MenuItem value="allmessages">All messages</MenuItem>
            <MenuItem value="unreadmessages">Unread messages</MenuItem>
            <MenuItem value="mentions">Mentions</MenuItem>
          </Select>
        </FormControl>
        <hr className="divider" />
        <div className="group-sections">
          <p>Collaborations</p>
          <Link onClick={markAllAsRead} sx={{ cursor: "pointer" }}>
            Mark all as read
          </Link>
        </div>
        <div className="group-list">
          {loading ? (
            <div style={{ textAlign: "center", padding: "20px" }}>
              Loading...
            </div>
          ) : filteredGroups.length > 0 ? (
            filteredGroups.map((group) => (
              <div
                key={group.id}
                className={`group-item ${activeGroup?.id === group.id ? "active" : ""
                  }`}
                // onClick={() => setActiveGroup(group)}
                onClick={() => handleSetActiveGroup(group)}
              >
                <div className="group-header">
                  <span className="group-name">
                    {group.collabrationgroupname}
                  </span>
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 6 }}
                  >
                    {group.IsMentioned && activeGroup?.id !== group.id && (
                      <Badge
                        badgeContent={"@"}
                        sx={{
                          "& .MuiBadge-badge": {
                            backgroundColor: "#f76a71ff",
                            color: "white",
                            minWidth: 18,
                            height: 18,
                            fontSize: 12,
                            lineHeight: "18px",
                            right: 0,
                            transform: "none",
                            position: "static",
                          },
                        }}
                      />
                    )}
                    {group.total_unreads > 0 &&
                      activeGroup?.id !== group.id && (
                        <Badge
                          badgeContent={group.total_unreads}
                          sx={{
                            "& .MuiBadge-badge": {
                              backgroundColor: "#6264A7",
                              color: "white",
                              minWidth: 18,
                              height: 18,
                              fontSize: 12,
                              lineHeight: "18px",
                              right: 0,
                              transform: "none",
                              position: "static",
                            },
                          }}
                        />
                      )}
                  </div>
                </div>
                <small>
                  Updated{" "}
                  {group.last_updated
                    ? formatDate(group.last_updated)
                    : formatDate(group.updated_at)}
                </small>
              </div>
            ))
          ) : (
            <div className="no-data-card">
              <div className="emoji">📭</div>
              <div className="title">No Data Found</div>
              <div className="desc">
                Try refreshing or adjusting your filters to see results.
              </div>
            </div>
          )}
        </div>
        {/* written this code for suggested topic on 08 oct 2025 start here */}
        {/* Right Panel - Suggested Topics */}
        <div className="suggested-section">
          <h4>💡 Suggested Topics</h4>
          {topic.length > 0 ? (
            <div className="suggested-list">
              {topic.map((topicName, index) => (
                <div key={index} className="suggested-item">
                  {topicName}
                </div>
              ))}
            </div>
          ) : (
            <div className="no-data-card">
              <div className="emoji">🔍</div>
              <div className="title">No Data Found</div>
              <div className="desc">
                Start a conversation or explore other groups to see suggestions
                appear here.
              </div>
            </div>
          )}
        </div>

        {/* written this code for suggested topic on 08 oct 2025 end here */}
      </div>

      {/* Chat Panel */}
      <div className="main-panel">
        {activeGroup ? (
          <>
            <div className="main-panel-header">
              <div>
                <div className="header-left">
                  <h3>{activeGroup?.collabrationgroupname || "General"}</h3>

                  {isTouchDevice ? (
                    <>
                      <div
                        className="participants"
                        onClick={(e) =>
                          setParticipantsAnchorEl(e.currentTarget)
                        }
                      >
                        <GroupIcon fontSize="small" />
                        <span style={{ marginLeft: "4px", fontSize: "13px" }}>
                          {participants.length} participants
                        </span>
                      </div>
                      <Popover
                        open={Boolean(participantsAnchorEl)}
                        anchorEl={participantsAnchorEl}
                        onClose={() => setParticipantsAnchorEl(null)}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "left",
                        }}
                        PaperProps={{
                          sx: {
                            bgcolor: "#e4e4f0",
                            padding: "10px 16px",
                            maxWidth: "260px",
                          },
                        }}
                      >
                        <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                          {participants.length > 0 ? (
                            participants.map((p) => {
                              const cleanName = p.user_name
                                ?.replace(/_+/g, " ")
                                .trim()
                                .replace(/\s+/g, " ");

                              const nameParts = cleanName
                                ? cleanName.split(" ")
                                : [];
                              const initials =
                                nameParts.length >= 2
                                  ? nameParts[0][0].toUpperCase() +
                                  nameParts[
                                    nameParts.length - 1
                                  ][0].toUpperCase()
                                  : nameParts[0]?.[0]?.toUpperCase() || "?";

                              return (
                                <div
                                  key={p.id}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                    marginBottom: "6px",
                                  }}
                                >
                                  <Avatar
                                    sx={{
                                      width: 28,
                                      height: 28,
                                      fontSize: "13px",
                                    }}
                                  >
                                    {initials}
                                  </Avatar>
                                  <span
                                    style={{
                                      fontSize: "13px",
                                      color: "black",
                                    }}
                                  >
                                    {p.user_name}
                                  </span>
                                </div>
                              );
                            })
                          ) : (
                            <span>No participants</span>
                          )}
                        </div>
                      </Popover>
                    </>
                  ) : (
                    <Tooltip
                      title={
                        participants.length > 0 ? (
                          <div
                            style={{
                              padding: "8px 12px",
                              maxWidth: "260px",
                              maxHeight: "200px",
                              overflowY: "auto",
                            }}
                          >
                            {participants.map((p) => {
                              const cleanName = p.user_name
                                ?.replace(/_+/g, " ")
                                .trim()
                                .replace(/\s+/g, " ");

                              const nameParts = cleanName
                                ? cleanName.split(" ")
                                : [];
                              const initials =
                                nameParts.length >= 2
                                  ? nameParts[0][0].toUpperCase() +
                                  nameParts[
                                    nameParts.length - 1
                                  ][0].toUpperCase()
                                  : nameParts[0]?.[0]?.toUpperCase() || "?";

                              return (
                                <div
                                  key={p.id}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                    marginBottom: "6px",
                                  }}
                                >
                                  <Avatar
                                    sx={{
                                      width: 28,
                                      height: 28,
                                      fontSize: "13px",
                                    }}
                                  >
                                    {initials}
                                  </Avatar>
                                  <span
                                    style={{ fontSize: "13px", color: "black" }}
                                  >
                                    {p.user_name}
                                  </span>
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          "No participants"
                        )
                      }
                      arrow
                      placement="bottom"
                      componentsProps={{
                        tooltip: {
                          sx: {
                            bgcolor: "#e4e4f0",
                            "& .MuiTooltip-arrow": { color: "#e4e4f0" },
                          },
                        },
                      }}
                    >
                      <div
                        className="participants"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                          color: "#444",
                        }}
                      >
                        <GroupIcon fontSize="small" />
                        <span style={{ marginLeft: "4px", fontSize: "13px" }}>
                          {participants.length} participants
                        </span>
                      </div>
                    </Tooltip>
                  )}
                </div>

                <span
                  style={{
                    fontSize: "10px",
                    color: "#757575",
                    display: "block",
                    marginTop: "-3px",
                  }}
                >
                  Collaboration last updated{" "}
                  {messages[activeGroup?.id]?.length > 0
                    ? formatDates(
                      new Date(
                        Math.max(
                          ...messages[activeGroup.id].map((m) =>
                            new Date(m.date).getTime()
                          )
                        )
                      )
                    )
                    : CollobrationformatDates(activeGroup.updated_at)}
                </span>
              </div>
              <IconButton>
                { /* <MoreVertIcon /> */}
              </IconButton>
            </div>

            <div
              className="message-area"
              ref={messageContainerRef}
              onScroll={handleScroll}
              style={{ overflowY: "auto", flexGrow: 1 }}
            >
              {(messages[activeGroup?.id] || [])
                .sort((a, b) => new Date(a.date) - new Date(b.date))
                .map((msg) => (
                  <div
                    key={msg.id}
                    className={`message-item ${msg.username === currentUser ? "sent" : "received"
                      }`}
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      marginBottom: "12px",
                    }}
                  >
                    {msg.username !== currentUser && (
                      <Avatar
                        style={{
                          marginRight: "8px",
                          width: "30px",
                          height: "30px",
                          marginTop: "20px",
                          fontSize: "14px",
                        }}
                      >
                        {(() => {
                          if (!msg.userData) return "";
                          const parts = msg.userData
                            .trim()
                            .split(/[_\s]+/)
                            .filter((p) => p.length > 0);
                          if (parts.length >= 2) {
                            return (
                              parts[0].charAt(0).toUpperCase() +
                              parts[parts.length - 1].charAt(0).toUpperCase()
                            );
                          }
                          return parts[0].charAt(0).toUpperCase();
                        })()}
                      </Avatar>
                    )}
                    <div className="message-wrapper">
                      <div
                        style={{
                          fontSize: "10px",
                          color: "#666",
                          marginBottom: "0px",
                        }}
                      >
                        <strong>
                          {msg.username === currentUser ? "You" : msg.userData}
                        </strong>{" "}
                        <span>{formatDates(msg.date)}</span>
                      </div>
                      <div
                        className="message-bubble"
                        style={{
                          fontSize: "13px",
                          background:
                            msg.username === currentUser
                              ? "#e4e4f0"
                              : "#F1F1F1",
                          borderRadius: "8px",
                        }}
                      >
                        <div>{renderMessageWithMentions(msg.message)}</div>
                      </div>
                    </div>
                  </div>
                ))}

              <div ref={messageEndRef} />
            </div>

            <div
              className="message-input-area"
              style={{ position: "relative" }}
            >
              <TextField
                id="chat-input"
                fullWidth
                placeholder="Type a message... (use @ to mention someone)"
                value={newMessage}
                onChange={(e) => {
                  const v = e.target.value;
                  setNewMessage(v);
                  const caret = e.target.selectionStart;
                  const uptoCaret = v.slice(0, caret);
                  const lastAt = uptoCaret.lastIndexOf("@");

                  if (lastAt !== -1) {
                    const query = uptoCaret.slice(lastAt + 1);
                    if (query.includes(" ")) {
                      closeMention();
                    } else {
                      setMentionQuery(query);
                      openMentionAt(e.target);
                    }
                  } else {
                    closeMention();
                  }
                }}
                onKeyDown={handleKeyDownInput}
              />

              <IconButton
                sx={{ backgroundColor: "#6264A7", color: "white" }}
                onClick={handleSend}
              >
                <SendIcon />
              </IconButton>

              {/* Mention suggestions popup */}
              {showSuggestions && (
                <div
                  className={`mention-suggestions ${isTouchDevice ? "touch" : ""
                    }`}
                  style={{
                    position: "absolute",
                    bottom: "56px",
                    left: 16,
                    zIndex: 30,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                    background: "white",
                    borderRadius: 8,
                    maxHeight: 220,
                    overflow: "auto",
                    width: 320,
                  }}
                >
                  {filteredSuggestions.length === 0 ? (
                    <div style={{ padding: 8 }}>No matches</div>
                  ) : (
                    filteredSuggestions.map((p, idx) => (
                      <div
                        key={p.id}
                        className={`suggestion-item ${idx === selectedSuggestionIndex ? "active" : ""
                          }`}
                        onMouseDown={(e) => {
                          e.preventDefault();
                          insertMention(p);
                        }}
                        onTouchStart={() => insertMention(p)}
                        style={{
                          padding: 8,
                          display: "flex",
                          gap: 8,
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        {!p._everyone && (
                          <Avatar sx={{ width: 28, height: 28, fontSize: 13 }}>
                            {(p.user_name || "")[0]?.toUpperCase()}
                          </Avatar>
                        )}
                        <div>
                          <div style={{ fontSize: 13, fontWeight: 600 }}>
                            {p._everyone ? "@Everyone" : p.user_name}
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              )}
            </div>
          </>
        ) : (
          <div
            className="welcome-placeholder"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              textAlign: "center",
              color: "#555",
            }}
          >
            <GroupIcon sx={{ fontSize: 60, color: "#888", mb: 2 }} />
            <h2 style={{ margin: 0 }}>Welcome to Collaboration</h2>
            <p style={{ marginTop: "8px", fontSize: "14px", color: "#777" }}>
              Select a group from the left panel to start chatting
            </p>
          </div>
        )}
      </div>

      <AddCollobrationModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onSave={handleCreateGroup}
        formData={formData}
        setFormData={setFormData}
        isEditModel={false}
        groupId={groupId}
        apiError={apiError}
        clearApiError={() => setApiError("")}
      />
    </div>
  );
};

export default Chats;
